



















































































































































import { Component, Vue } from 'vue-property-decorator';

import Common from '../../common/Common';
import CsvParse from 'csv-parse';
import TsvUtil from '../../common/TsvUtil';

import BackButton from '@/components/BackButton.vue';
import SectionCourseManagement from '@/components/SectionCourseManagement.vue';
import ValidateStatus from '@/components/ValidateStatus.vue';

import ModalCourseManagement from '@/components/ModalCourseManagement.vue'
import { DbCourseManagement, DbCourseManagementDetails } from "../../database/DbCourseManagement";
import { ResultDbCourseManagementDetails, DbUtile } from '../../database/DbUtile';
import { DbUser, DbUserCourseManagement } from '../../database/DbUser';
import { ResultUser } from "../../database/DbUtile";
import { AuthUtile } from "../../auth/AuthUtile";

@Component({
  components: {
    BackButton,
    SectionCourseManagement,
    ValidateStatus
  }
})
export default class CourseManagementDetails extends Vue {
  private authUtile = new AuthUtile();
  private dbUtile = new DbUtile();

  // 入力チェック
  private validateStatus = {
    error: false,
    message: ""
  };

  private courseManagementId: string | null = null;
  private currentCourseManagement: DbCourseManagement | null = null;

  //選択中の 詳細
  private currentCourseManagementDetailsId: string | null = null;
  private currentCourseManagementDetails: DbCourseManagementDetails | null = null;

  private rows: {}[] = [];
  private currentDetails: ResultDbCourseManagementDetails[] = [];
  private addedDetails: {}[] = [];
  private deletedDetails: {}[] = [];


  // ダミー
  private detailsTsv = ""
        + "1\tC001\t01. ○○○○\tオンデマンド\t477911104\t不可\t\t2020/12/07 00:00:00\t2020/12/16 23:59:59\t50\txxxxxxxxxxx\n"
        + "2\tC001\t01. ○○○○\tオンデマンド\t477911104\t不可\t\t2020/12/07 00:00:00\t2020/12/16 23:59:59\t50\txxxxxxxxxxx\n"
        + "3\tC001\t01. ○○○○\tライブ配信\t\t\thttps://vimeo.com/477911104/5f9bc90ada\t2020/12/07 00:00:00\t2020/12/16 23:59:59\t50\txxxxxxxxxxx\n";

// https://vimeo.com/477911104/5f9bc90ada
// https://vimeo.com/468002589/1a241f34c6

  created() {
    console.log('created');
    this.authUtile.checkAuthorizedAdmin()
      .then(() => {
        if (this.$route.params['id'] == 'new') {
          this.currentCourseManagement = new DbCourseManagement();
        } else {
          this.courseManagementId = this.$route.params['id'];
          this.getCourseManagementDetails(this.courseManagementId);
        }
      })
      .catch((e) => {
        console.error('checkAuthorizedAdmin:', e);
        alert(e);
        this.$router.push('/admin/login/');
      });
  }

  getCourseManagementDetails(id: string){
    if(id == null) {
      // 新規の場合
      this.currentCourseManagement = new DbCourseManagement();
      return;
    }
    this.dbUtile.getCourseManagement(id)
      .then((data) => {
        this.currentCourseManagement = data;
        // this.currentCourseManagement.detailsTsv = this.detailsTsv;

        // 講習詳細 一覧
        this.dbUtile.getCourseManagementDetails(id)
          .then((r) => {
            console.log('rows', r);
            // ソート
            const rows = this.sortCourseManagementDetails(r);
            this.$set(this, "rows", r);
            this.currentDetails = rows;
          }).catch((e) => {
            console.error(e);
          });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  // ソート
  sortCourseManagementDetails(rows: ResultDbCourseManagementDetails[]): ResultDbCourseManagementDetails[]{
    return rows.sort((a,b) => {
      // 分科会番号 章IDで並び替え
      //  subcommitteeNumber　/ chapterID
      if((a == null) || (b == null)){
        return 0;
      }
      const aCourseManagementDetails = a.courseManagementDetails!;
      const bCourseManagementDetails = b.courseManagementDetails!;
      // 分科会番号
      if(aCourseManagementDetails.subcommitteeNumber > bCourseManagementDetails.subcommitteeNumber){
        return 1;
      }
      else if(aCourseManagementDetails.subcommitteeNumber < bCourseManagementDetails.subcommitteeNumber){
        return -1;
      }

      // 章ID
      if(aCourseManagementDetails.chapterID > bCourseManagementDetails.chapterID){
        return 1;
      }
      else if(aCourseManagementDetails.chapterID < bCourseManagementDetails.chapterID){
        return -1;
      }
      return 0;
    });
  }

  // 入力チェック
  validate(): boolean {
        this.validateStatus = {
          error: false,
          message: ""
        };
        // 講習ID
        if (Common.isValidate(this.currentCourseManagement!.courseId, this.validateStatus, "講習ID は必須入力です") == false){
            return false;
        }
        // 講習名
        if (Common.isValidate(this.currentCourseManagement!.name, this.validateStatus, "講習名 は必須入力です") == false){
            return false;
        }
        //領域、期間、講師、定員は必須 としない
        // 期間の書式チェック
        if (this.currentCourseManagement!.from != "") {
          console.log("from", this.currentCourseManagement!.from);
          if(Common.ckDate(this.currentCourseManagement!.from) == false){
            this.validateStatus.error = true;
            this.validateStatus.message = "期間 開始日 は存在する日付を入力してください";
            return false;
          }
        }
        if (this.currentCourseManagement!.to != ""){
          console.log("to", this.currentCourseManagement!.to);
          if(Common.ckDate(this.currentCourseManagement!.to) == false){
            this.validateStatus.error = true;
            this.validateStatus.message = "期間 終了日 は存在する日付を入力してください";
            return false;
          }
        }
        if ((this.currentCourseManagement!.from != "") && (this.currentCourseManagement!.to != "")){
          if (new Date(this.currentCourseManagement!.from) > new Date(this.currentCourseManagement!.to)){
            this.validateStatus.error = true;
            this.validateStatus.message = "期間 を正しく入力してください";
            return false;
          }
        }
        // 定員「0」「-1」「12.3」で登録できる → 定員は1以上の整数であるかチェック
        // console.log("capacity", typeof this.currentCourseManagement!.capacity);
        const capacity: any = this.currentCourseManagement!.capacity;
        console.log("capacity", capacity);
        if (( capacity !== null) && (capacity !== "")) {
          const c = Number(`${capacity}`);
          console.log("typeof c", typeof c);
          if (( typeof c !== 'number')
              || (Common.isInteger(c) == false)
              || (c <= 0)){
              this.validateStatus.error = true;
              this.validateStatus.message = "定員 は1以上の整数を入力してください";
              return false;
          }
        }
        if (Common.isValidate(this.currentCourseManagement!.detailsTsv, this.validateStatus, "目次 は必須入力です") == false){
            return false;
        }
        return true;
    }

  // DB に 講習 情報を保存する
  addCourseManagement(event: any) {
      // 入力チェック
      if (this.validate() == false) {
          return
      }
      console.log('courseManagementId', this.courseManagementId);

      // ボタンを押せないように設定
      event.target.classList.add('is-loading');

      // 新規登録
      if ((this.courseManagementId == null) || (this.courseManagementId == '')) {
        this.dbUtile.addCourseManagement(this.courseManagementId, this.currentCourseManagement! )
          .then((courseManagement: DbCourseManagement) => {
            console.log("addCourseManagement success", courseManagement);
            this.courseManagementId = courseManagement.uid!;
            this.addDbCourseManagementDetails( this.courseManagementId!, this.currentCourseManagement!.detailsTsv)
              .then(() => {
                console.log("addDbCourseManagementDetails success");
                // 一覧を更新
                setTimeout(()=>{
                  this.getCourseManagementDetails(this.courseManagementId!);
                },3000);

                // ボタンを戻す
                event.target.classList.remove('is-loading');
                alert('登録しました');
              })
              .catch((e) => {
                console.error("addDbCourseManagementDetails", e);
              });
          })
          .catch((e) => {
              console.error(e);
              //TODO エラー 表示
          });
      /*
      // 保存処理
      this.dbUtile.addCourseManagement(this.courseManagementId, this.currentCourseManagement! )
          .then((courseManagement: DbCourseManagement) => {
            console.log("addCourseManagement success", courseManagement);
            if ((this.courseManagementId == null) || (this.courseManagementId == '')) {
              this.courseManagementId = courseManagement.uid!;
            }
            this.dbUtile.deleteCourseManagementDetailAll(this.courseManagementId!)
              .then(() => {
                this.addDbCourseManagementDetails( this.courseManagementId!, this.currentCourseManagement!.detailsTsv)
                    .then(() => {
                        console.log("addDbCourseManagementDetails success");
                        // 一覧を更新
                        setTimeout(()=>{
                          this.getCourseManagementDetails(this.courseManagementId!);
                          alert('登録しました');
                        },3000);
                    })
                    .catch((e) => {
                        console.error("addDbCourseManagementDetails", e);
                    });
              });
          })
          .catch((e) => {
              console.error(e);
              //TODO エラー 表示
          });
          */

      }
      // 更新
      else {
        this.dbUtile.addCourseManagement(this.courseManagementId, this.currentCourseManagement!)
          .then(() => {
            this.updateDbCourseManagementDetails(this.courseManagementId!, this.currentCourseManagement!.detailsTsv)
              .then(() => {
                // 一覧を更新
                setTimeout(()=>{
                  this.dbUtile.updateUserHistoryStatus(this.courseManagementId!)
                    .then(() => {
                      this.getCourseManagementDetails(this.courseManagementId!);

                      // ボタンを戻す
                      event.target.classList.remove('is-loading');
                      alert('登録しました');
                    })
                    .catch((e) => {
                      console.error(e);
                      this.getCourseManagementDetails(this.courseManagementId!);

                      // ボタンを戻す
                      event.target.classList.remove('is-loading');
                      alert('登録しました');
                    });
                },3000);
              })
              .catch((e) => {
                console.error(e);
              });
          })
          .catch((e) => {
            console.error(e);
          });
      }
  }

  // tsv をパースする
  formatDetailsTsv(data: string): Promise<string[]> {
    return new Promise((resolve,reject) => {
      CsvParse(data, {
          delimiter: '\t',
          quote: '"',
          escape: '"',
      }, (err, records) => {
        console.log("records", records);
        resolve(records);
      });
    });
  }

  // 詳細登録
  addDbCourseManagementDetails(id: string, data: string): Promise<void> {
      return new Promise((resolve,reject) => {
          if (data.length == 0){
              resolve();
              return;
          }

          this.formatDetailsTsv( data )
            .then((records) => {
              records.forEach((columns, index) => {
                console.log("columns", columns);
                if(columns.length == 1){
                  return;
                }

                // DbCourseManagementDetails 新規登録
                const src = new DbCourseManagementDetails();
                src.subcommitteeNumber = columns[0];
                src.chapterID = columns[1];
                src.lectureName = columns[2];
                src.classification = columns[3];
                src.videoID = columns[4];
                src.playbackSpeedChange = columns[5];
                src.meetingURL = columns[6];
                src.from = columns[7];
                src.to = columns[8];
                src.time = columns[9];
                src.description = columns[10];
                console.log('src', src);
                this.dbUtile.addCourseManagementDetails(id, src)
                    .then((data) => {
                        console.log('data', data);
                    })
                    .catch((e) => {
                        console.log("e", e);
                        reject();
                    });
              });
              resolve();
            })
            .catch((e) => {
              console.log("e", e);
              reject();
            });
      });
  }

  // 詳細更新
  updateDbCourseManagementDetails(id: string, data: string): Promise<void> {
    return new Promise((resolve,reject) => {
      if (data.length == 0) {
        resolve();
        return;
      }

      if (this.currentDetails === null) {
        resolve();
        return;
      }

      // 削除対象の章ID
      const deletedDetailsID: string[] = [];

      this.formatDetailsTsv( data )
        .then((records) => {
          records.forEach((columns, index) => {
            console.log("columns", columns);
            if(columns.length == 1){
              resolve();
              return;
            }

            // DbCourseManagementDetails 更新
            // (章ID)をキーとする
            let targetDetailsID: string | null = "";
            let isMatched = false;

            this.currentDetails.forEach(row => {
              // 現在の詳細に一致する（章ID）があれば更新
              if (!isMatched && columns[1] === row!.courseManagementDetails!.chapterID) {
                //alert(row!.id);
                targetDetailsID = row!.id;
                isMatched = true;
              }
            });

            const src = new DbCourseManagementDetails();
            src.subcommitteeNumber = columns[0];
            src.chapterID = columns[1];
            src.lectureName = columns[2];
            src.classification = columns[3];
            src.videoID = columns[4];
            src.playbackSpeedChange = columns[5];
            src.meetingURL = columns[6];
            src.from = columns[7];
            src.to = columns[8];
            src.time = columns[9];
            src.description = columns[10];
            console.log('src', src);

            if (isMatched) {
              //alert("更新");
              this.dbUtile.updateCourseManagementDetails(id, targetDetailsID, src);
            }
            else {
              // 現在の詳細に一致する（章ID）がなければ追加
              //alert("追加");
              this.dbUtile.addCourseManagementDetails(id, src)
                .then((data) => {
                  console.log('data', data);
                  this.addedDetails.push(data);
                })
                .catch((e) => {
                  console.error(e);
                  reject();
                });
            }
          });
        });

      // 現在の詳細の（章ID）がTSVになければ削除
      this.currentDetails.forEach(row => {
          this.formatDetailsTsv( data )
            .then((records) => {
              const targetDetailsID: string = row!.id!;
              let isMatched = false;

              records.forEach((columns, index) => {
                //alert(columns[1]);
                if (!isMatched && columns[1] == row!.courseManagementDetails!.chapterID) {
                  isMatched = true;

                }
              })

              if (!isMatched) {
                this.dbUtile.deleteCourseManagementDetail(id, targetDetailsID!);
                 deletedDetailsID.push(targetDetailsID!);
              }
            })
            .catch((e) => {
              console.error(e);
              reject();
            });
        });

        // 受講者の履歴更新
        this.dbUtile.getCourseManagementUsersExcelText(id)
          .then((usersExcelText)=> {
              // 受講登録者がいない場合はreturn
              if (usersExcelText == null) {
                resolve();
                return;
              }

              TsvUtil.parse(usersExcelText.text)
                .then((users) => {
                  //alert(users.length);
                  if (users.length == 0) {
                    resolve();
                    return;
                  }

                  const promises: Promise<any>[] = [];
                  users.forEach(async (u) => {
                    promises.push( this.updateUserHistory(u, id, deletedDetailsID) );
                  })
                  /*
                  Promise.all(promises)
                        .then((res) => {
                          setTimeout(()=>{
                              this.wait();
                            },3000);
                          res.forEach(userId => {
                            //this.dbUtile.updateUserHistoryStatus(userId, id);
                          });
                        });
                        */
                  resolve();
                })
                .catch((e) => {
                  console.error(e);
                  reject();
                });
          })
          .catch((e) => {
              console.error(e);
              reject();
          });
    });
  }

  // 受講履歴を更新
  updateUserHistory(u: DbUser, id: string, deletedDetailsID: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
        return this.dbUtile.addUser(this.courseManagementId!, u)
          .then((userData: ResultUser) => {
              // ユーザーの講習一覧にも登録する必要がある
              const userCourseManagement = new DbUserCourseManagement();
              userCourseManagement.id = this.courseManagementId!;
              const userId = userData.id!;
              this.dbUtile.addUserCourseManagement(userId, userCourseManagement)
                  .then((rows: any) => {
                    console.log('addUser success', userId);
                    //resolve();
                    this.addHistoryManagement(userId, u)
                      .then(() => {
                        deletedDetailsID.forEach((did) => {
                          this.dbUtile.deleteUserHistoryDetail(userId, id, did!);
                        });
                        resolve(userId);

                        //this.dbUtile.updateUserHistoryStatus(userId, id)
                          //.then(() => {
                            //resolve();
                          //});
                      });

                    //deletedDetailsID.forEach((did) => {
                    //  this.dbUtile.deleteUserHistoryDetail(userId, id, did!);
                    //});


                  });

              //this.dbUtile.updateUserHistoryStatus(userId, id)
              //resolve();
          })
          .catch((e: any) => {
              console.error(e);
              reject();
          });
    });
  }

  // 履歴を追加する
  addHistoryManagement(userId: string, u: DbUser): Promise<void> {
    return new Promise((resolve,reject) => {
      // ログ登録
      const ucm = new DbUserCourseManagement();
      ucm.id = this.courseManagementId!;
      ucm.status = DbUserCourseManagement.STATUS.NotAttended;

      // 履歴を追加する
      this.dbUtile.addHistoryManagement(userId, u, this.courseManagementId!, ucm)
        .then(() => {
          console.log("addHistoryManagement success");
        })
        .catch(() => {
          //console.error(e);
          reject();
        });

      // 履歴詳細を追加する
      this.dbUtile.addHistoryManagementDetails(userId, u, ucm, this.courseManagementId!)
        .then(() => {
          console.log("addHistoryManagementDetails success");
        })
        .catch(() => {
          //console.error(e);
          reject();
        });

        resolve();
    });
  }
}
